import { makeAutoObservable } from "mobx";

/**
 * Глобальный реестр активного поповера.
 * Гарантирует, что одновременно открыт может быть только один поповер
 * (фильтры, сортировка и т.п.).
 */
class PopoverStore {
  activeId: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  isOpen = (id: string): boolean => this.activeId === id;

  open = (id: string) => {
    this.activeId = id;
  };

  close = (id?: string) => {
    if (id === undefined || this.activeId === id) {
      this.activeId = null;
    }
  };

  toggle = (id: string) => {
    this.activeId = this.activeId === id ? null : id;
  };
}

export const popoverStore = new PopoverStore();
export type { PopoverStore };
